import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { OnlySaveButton } from 'components/base/BottomStepComponent';

import CouponGeneralBrand from '../../../assets/images/coupon/preview/SingleCoupon_brand.png';
import CouponDefaultPreview from '../../../assets/images/coupon/preview/SingleCoupon_default.png';
import CouponDetailContent from '../../../assets/images/coupon/preview/SingleCoupon_detailContent.png';
import CouponDetailTitle from '../../../assets/images/coupon/preview/SingleCoupon_detailTitle.png';
import CouponKeyVisualImage from '../../../assets/images/coupon/preview/SingleCoupon_image.png';
import CouponInstructionContent from '../../../assets/images/coupon/preview/SingleCoupon_instructionContent.png';
import CouponInstructionTitle from '../../../assets/images/coupon/preview/SingleCoupon_instructionTitle.png';
import CouponGeneralStore from '../../../assets/images/coupon/preview/SingleCoupon_store.png';
import CouponGeneralName from '../../../assets/images/coupon/preview/SingleCoupon_title.png';
import { couponValidateV2 } from './CreateCouponValidate';
import { COUPON_PAGE_CONFIG } from './CreateCouponStepOneV2Config';

const inputWithImageConfig = {
  name: CouponGeneralName,
  relatedBrand: CouponGeneralBrand,
  selectedStores: CouponGeneralStore,
  coverPhoto: CouponKeyVisualImage,
  otherPhotos: CouponKeyVisualImage,
  instructionTitle: CouponInstructionTitle,
  instructionContent: CouponInstructionContent,
  detailsTitle: CouponDetailTitle,
  detailsContent: CouponDetailContent,
};
const defaultImage = CouponDefaultPreview;

const CreateCouponStepOneV2 = ({
}) => {
  const params = useParams();
  const couponTemplateId = params.id;
  const isEditMode = !!couponTemplateId;
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    formState: { errors },
    getValues,
    setError,
    clearErrors,
  } = useFormContext();

  const errorLanguage = Object.keys(errors?.translations || [])?.[0];
  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);

  const saveAction = () => {
    const isValid = couponValidateV2({
      getValues,
      setError,
      clearErrors,
    });
    if (!isValid) {
      return;
    }

    if (isEditMode) {
      dispatch({
        type: 'createCoupon/updateCouponTemplateInput',
        payload: {
          data: getValues(),
        },
      });
    } else {
      dispatch({
        type: 'createCoupon/createCouponTemplate',
        payload: {
          data: getValues(),
        },
      });
    }
  };

  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={COUPON_PAGE_CONFIG}
        hidePreview={false}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
        sectionStyle='create-campaign-streamline-step-2'
      />
      <OnlySaveButton
        saveText={"Save"}
        saveAction={saveAction}
      />
    </>
  );
}
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps)(CreateCouponStepOneV2);

